import React from "react";

const TextileMillProductsIcon = ({
  color = "#5D5D5D",
  width = "19",
  height = "19",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.316406 18.6845V7.64067L6.74523 4.90842V6.74523L11.3372 4.88546V7.66363H18.6845V18.6845H0.316406ZM1.69401 17.3069H17.3069V9.04583H9.95964V6.92891L5.36762 8.76571V6.95187L1.69401 8.58203V17.3069ZM8.81163 15.0109H10.1892V11.3372H8.81163V15.0109ZM5.13802 15.0109H6.51563V11.3372H5.13802V15.0109ZM12.4852 15.0109H13.8628V11.3372H12.4852V15.0109ZM18.6845 7.66363H14.5517L15.4701 0.316406H17.7661L18.6845 7.66363Z"
        fill={color}
      />
    </svg>
  );
};

export default TextileMillProductsIcon;
